import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useLanguageState } from '../../globalStates/LanguageState';
import { useReferenceDataState } from '../../globalStates/ReferenceDataState';

const LanguagesWrapper = styled.div`
    display: flex;
    align-items: center;
    & > * {
        margin: 0;
        cursor: pointer;

        &.active {
            font-weight: 500;
        }
    }
`

const Language = styled.label`
`

const Languages: React.FC<{}> = (props) => {
    const languageState = useLanguageState()
    const referenceState = useReferenceDataState()
    const languageSwitchHandler = useCallback((lang) => {
        languageState.setLanguage(lang)
        referenceState.init()
    }, [languageState, referenceState])
    return (
        <LanguagesWrapper>
            <Language className={"en" === languageState.getLanguage() ? "active" : ""} onClick={() => languageSwitchHandler("en")} >EN</Language>
            <label>&nbsp;|&nbsp;</label>
            <Language className={"de" === languageState.getLanguage() ? "active" : ""} onClick={() => languageSwitchHandler("de")} >DE</Language>
        </LanguagesWrapper>
    );
}

export default Languages;